import { AssetManifest, type AssetKey } from "./AssetManifest";

export type AssetMap = Record<AssetKey, HTMLImageElement>;

export async function loadAssets(
  onProgress?: (ratio: number) => void
): Promise<AssetMap> {
  const keys = Object.keys(AssetManifest) as AssetKey[];
  const total = keys.length;
  let done = 0;
  const out = {} as AssetMap;

  await Promise.all(
    keys.map(
      (key) =>
        new Promise<void>((resolve, reject) => {
          const img = new Image();
          img.decoding = "async";
          img.onload = () => {
            out[key] = img;
            done += 1;
            onProgress?.(done / total);
            resolve();
          };
          img.onerror = () =>
            reject(new Error(`Failed to load asset: ${AssetManifest[key]}`));
          img.src = AssetManifest[key];
        })
    )
  );

  return out;
}
